/* eslint-disable import/prefer-default-export */
export const getImportedResources = (state, resourceName) =>
  state[resourceName].partialImport.importedResources;
